import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_SERVICE_LOCATION_TYPE = 'GET_SERVICE_LOCATION_TYPE';
export const GET_SERVICE_LOCATION_TYPE_SUCCESS =
  'GET_SERVICE_LOCATION_TYPE_SUCCESS';
export const GET_SERVICE_LOCATION_TYPE_FAILURE =
  'GET_SERVICE_LOCATION_TYPE_FAILURE';

// Action Creators
export const fetchGetServiceLocationType = () => ({
  type: GET_SERVICE_LOCATION_TYPE,
});

export const fetchGetServiceLocationTypeSuccess = (data) => ({
  type: GET_SERVICE_LOCATION_TYPE_SUCCESS,
  payload: data,
});

export const fetchGetServiceLocationTypeFailure = (error) => ({
  type: GET_SERVICE_LOCATION_TYPE_FAILURE,
  payload: error,
});

// Thunk Function
export const getServiceLocationTypeCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetServiceLocationType(data, external));
    try {
      const response = await getMethodWithToken(
        url.getServiceLocationTypeListSuperAdmin
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetServiceLocationTypeSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetServiceLocationTypeFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetServiceLocationTypeFailure(error.message));
    }
  };
};
